module.exports = __webpack_public_path__ + "static/img/jszg_img_skfw_content.68d80cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jszg_img_skfw_content.png
// module id = OcDs
// module chunks = 0